"use strict";
exports.__esModule = true;
exports.createNewEvent = void 0;
function createNewEvent(eventName) {
    var event;
    if (typeof Event === "function") {
        event = new Event(eventName);
    }
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, true, true);
    }
    return event;
}
exports.createNewEvent = createNewEvent;
